<template>
  <div class="shop-footer">
    <div class="shop-footer__total">
      <div class="shop-footer__total-title">
        {{ $t('shopTotalLabel') }} <span>({{ $t('includingVat') }})</span>
      </div>
      <div class="shop-footer__total-value">{{ total }}</div>
    </div>
    <div class="shop-footer__actions">
      <ButtonComponent
        v-if="hasPrev"
        :label="$t('prev')"
        icon-placement="left"
        :icon="['fal', 'angle-left']"
        @click="$emit('prev')"
      />
      <ButtonComponent
        v-if="hasNext"
        :label="$t('next')"
        :icon="['fal', 'angle-right']"
        @click="$emit('next')"
      />

      <slot v-if="!hasNext" name="action" />
    </div>
  </div>
</template>

<script>
import { Currency } from './utils'

export default {
  props: {
    value: Object,
    hasNext: {
      type: Boolean,
      default: true,
    },
    hasPrev: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    selected() {
      if (!this.value) return []
      let items = []
      let target = this.value.categories

      const extract = x => {
        if (x.items && x.items.length) items.push(...(x.items.filter(i => i.selected) || []))
        if (x.categories && x.categories.length) x.categories.forEach(extract)
      }

      target.forEach(extract)

      return items
    },
    total() {
      let value = this.selected.reduce(
        (res, cur) => (res += cur.isDefault ? 0 : cur.product.gross),
        0,
      )
      return Currency(value)
    },
  },
}
</script>

<style lang="scss">
@import './styles/_variables';
.shop-footer {
  border-top: 1px solid $border-color;
  background-color: darken(white, 3%);
  padding: 1.5rem 2rem;

  @media (max-width: $shop-responsive) {
    padding: 1.5rem 1rem;
  }

  display: flex;
  align-items: center;
  justify-content: space-between;

  &__actions {
    & > * + * {
      margin-left: 1rem;

      @media (max-width: $shop-responsive) {
        margin-left: 0.5rem;
        justify-self: flex-end;
        align-self: flex-end;
      }
    }

    @media (max-width: $shop-responsive) {
      align-self: flex-end;
      .elder-button__label {
        display: none;
      }

      .elder-button__icon {
        padding: 0.6rem !important;
      }
      svg {
        font-size: 1.5rem;
      }
    }
  }

  &__total {
    &-title {
      span {
        opacity: 0.6;
        margin-left: 5px;
      }
    }
    &-value {
      font-size: 1.7em;
      font-weight: bold;
    }
  }
}
</style>
